import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gButton from "@/components/g-button/g-button.vue"
import gDataTable from "@/components/g-data-table/g-data-table.vue"
import gFileUpload from "@/components/g-file-upload/g-file-upload.vue"
import cnpjExistente from "@/components/popupCNPJExistente/cnpjExistente.vue"
import { CepService } from "@/shared/services/CEP";
import CidadeController from "@/shared/controllers/cidade/cidadeController"
import Tools from "@/shared/services/tools"
import EmpresaController from "@/shared/controllers/empresa/empresaController"
import ClienteDesenvolvimentoViewModel from "@/shared/view-models/ClienteDesenvolvimentoViewModel"
import ClienteDesenvolvimentoController from "@/shared/controllers/cliente/clienteDesenvolvimentoController"
import ClienteController from "@/shared/controllers/cliente/clienteController"
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import {mask} from 'vue-the-mask'
import InputClienteTelefone from "@/components/InputClienteTelefone/InputClienteTelefone.vue";

const name = 'ClienteEmDesenv'

export default {
    name,
    directives: {mask},
    components: {
        'g-card': gCard,
        'g-form': gForm,
        'g-button': gButton,
        'g-data-table': gDataTable,
        'g-file-upload': gFileUpload,
        'cnpj-existente': cnpjExistente,
        InputClienteTelefone
    },
    mounted(){
        EmpresaController.getEmpresasAtivas().requisicao
          .then(response => {
            this.EmpresaArray = response.data.data
            this.atualizaEmpresaRepresentante()
          });

          this.mitt.on('trocaEmpresaRepresentante', () => {
            this.atualizaEmpresaRepresentante()
          })
        this.popularDropDownEstado()
        this.popularDropDownSegmento()
        this.popularDropDownPerfilMaterial()
        this.popularDropDownPotencial()
        this.popularDropDownTipoContato()

        this.preencheEmpresa()

      if(this.$store.state.cliente != null && this.$store.state.cliente.clienteSituacao == 1)
      {

            this.popupjaexiste= false

            this.objCliente.cnpj = this.$store.state.cliente.cnpj
            this.objCliente.razaoSocial = this.$store.state.cliente.razaoSocial

            this.objCliente.RepresentanteId = this.$store.state.representanteSelecionadoId || this.$store.state.cliente.representanteId;

            this.objCliente.nomeFantasia = this.$store.state.cliente.nomeFantasia
            this.cep = this.$store.state.cliente.cep
            // this.bairro = (this.$store.state.cliente.enderecos).map(item => { return item.bairro })[0]
            this.objCliente.EstadoSelecionado = this.$store.state.cliente.estadoId
            this.objCliente.CidadeSelecionada = this.$store.state.cliente.cidadeId
            this.objCliente.cep = this.$store.state.cliente.cep

            this.objCliente.ClienteTipoId= this.$store.state.cliente.clienteTipoId
            this.objCliente.PerfilMaterialSelecionado = this.$store.state.cliente.perfilMaterial
            this.objCliente.PotencialSelecionado = this.$store.state.cliente.potencialCliente

            this.codigo= this.$store.state.cliente.codigoExterno
            this.cv = this.$store.state.cliente.curvaCliente

            this.objCliente.pis = this.$store.state.cliente.pisCofins
            this.objCliente.icms = this.$store.state.cliente.icms
            this.objCliente.ipi = this.$store.state.cliente.ipi
            this.objCliente.telefone = this.$store.state.cliente.numeroTelefone

            this.objCliente.NumeroSuframa = this.$store.state.cliente.numeroSuframa

            this.objCliente.checkboxExt = this.DesativaEstado = this.desabilitado = this.$store.state.cliente.clienteExterior;

            if(this.$store.state.cliente.contatos != null) {
              this.$store.state.cliente.contatos.forEach((Element) => {
                let variavel =
                {"Sequencia": Element.sequencia, "TipoContato": "Comercial", "TipoContatoValue": Element.tipoContato, "NomeContato": Element.nomeContato, "NomeFuncao": Element.nomeFuncao,
                "Site": Element.clienteSite, "Email": Element.email.trim(), "NumeroTelefone": Element.numeroTelefone, "NumeroCelular": Element.numeroCelular,
                "TelefoneExterior": Element.numeroTelefoneExterior, "CelularExterior": Element.numeroCelularExterior}

                this.informacaotelefone.push(variavel)
              })
            }
            if(this.$store.state.cliente.possuiEmpresaEdicao == true){
              this.objCliente.EmpresaSelecionada = this.$store.state.cliente.empresaId
            }
            this.buscarcidade()

            if(this.$store.state.cliente.numeroSuframa != null || this.$store.state.cliente.numeroSuframa !== '')
            {
              this.suframaSimNao = 'sim'
              this.verificanomecidade()
            }

            this.clienteId = this.$store.state.cliente.id

      }

      this.preencheEmpresa()

    },

    watch: {
      // cep(){
      //   if(this.cep === ''){
      //     this.objCliente.EstadoSelecionado = ''
      //     this.objCliente.CidadeSelecionada = ''
      //     this.DesativaCidade = false
      //     this.DesativaEstado = false
      //   }
      // },

    PerfilMaterialArray(newValue){
      if (newValue.length > 0) {
        if(this.$store.state.cliente != null && this.$store.state.cliente.clienteSituacaoSwitch == 1)
        {
        this.PerfilMaterialSelecionado =  this.PerfilMaterialArray.find(x => x.enum == this.$store.state.cliente.perfilMaterial)
        }
      }
    },

    PotencialArray(newValue){
      if (newValue.length > 0) {
        if(this.$store.state.cliente != null && this.$store.state.cliente.clienteSituacaoSwitch == 1)
        {
        this.PotencialSelecionado= this.PotencialArray.find(x => x.enum == this.$store.state.cliente.potencialCliente)
        }
      }
    },

    EstadoSelecionado: function (newValue){
      if (newValue !== null)
        this.buscarcidade()
    },


    },
    setup(){
      return{
        v$: useVuelidate()
      }
    },

    validations(){
      return{
        objCliente:{
          cnpj: {required: helpers.withMessage("O campo de CNPJ é obrigatório", required)},
          razaoSocial: {required: helpers.withMessage("O campo de Razão Social é obrigatório", required)},
          nomeFantasia: {required: helpers.withMessage("O campo de Nome Fantasia obrigatório", required)},
          telefone: {required: helpers.withMessage("O campo de Telefone é obrigatório", required)},
          EmpresaSelecionada: {required: helpers.withMessage("É necessário selecionar uma empresa", required)},
          ClienteTipoId: {required: helpers.withMessage("É necessário selecionar um segmento", required)},
          PerfilMaterialSelecionado: {required: helpers.withMessage("É necessário selecionar um Perfil de Material", required)},
          PotencialSelecionado: {required: helpers.withMessage("É necessário selecionar um Potencial", required)},
          CidadeSelecionada: {required: helpers.withMessage("É necessário selecionar uma cidade", required)},
          EstadoSelecionado: {required: helpers.withMessage("É necessário selecionar um estado", required)},
        },
        informacaotelefone: {required: helpers.withMessage("É necessário adicionar pelo menos um contato", required)}
      }
    },

    data() {
        return {
          desabilitaGravar: false,
          sequencia:0,
          invalido24: false,
          teste24:'',
          styleImg: 'width: 350px; height: 350px; border: 1px solid #ccc; padding: 30px',
          popupEditImage: false,
          imageArray: [],
          index: 0,
          alteracaoListaContato: false,
          alteracaoLista: false,
          cidadenome: '',
          desabilitado: false,
          DesativaCidade: false,
          disabled: false,
          colunasTelefone: [
            {field: 'Sequencia', header: 'index', width: '50px', ordena: true},
            {field: 'TipoContato', header: 'Tipo de contato', width: '180px', ordena: true},
            {field: 'NomeContato', header: 'Nome do contato', width: '180px', ordena: true},
            {field: 'NomeFuncao', header: 'Função', width: '180px', ordena: true},
            {field: 'Site', header: 'Site', width: '180px', ordena: true},
            {field: 'Email', header: 'Email', width: '180px', ordena: true},
            {field: 'NumeroTelefone', header: 'Número de Telefone', width: '180px', ordena: true},
            {field: 'NumeroCelular', header:'Número de Celular', width: '180px', ordena: true},
            {field: 'TelefoneExterior', header: ' Telefone Exterior', width: '180px', ordena: true},
            {field: 'CelularExterior', header: ' Celular Exterior', width: '180px', ordena: true},

        ],
          informacaotelefone: [],
          Filtro: {
              'global': {value: null, matchMode: this.filtros.CONTAINS},
              'TipodeContato': {value: null, matchMode: this.filtros.CONTAINS},
              'NomeContato': {value: null, matchMode: this.filtros.CONTAINS},
              'NomeFuncao': {value: null, matchMode: this.filtros.CONTAINS},
              'Site': {value: null, matchMode: this.filtros.CONTAINS},
              'Email': {value: null, matchMode: this.filtros.CONTAINS},
              'NumeroTelefone': {value: null, matchMode: this.filtros.CONTAINS},
              'NumeroCelular': {value: null, matchMode:this.filtros.CONTAINS},
              'TelefoneExterior': {value: null, matchMode: this.filtros.CONTAINS},
              'CelularExterior': {value: null, matchMode: this.filtros.CONTAINS},
            },

            inputs: [],
            inputscelular: [],
            telefone:null,

            desabilitarcep:false,
            habilitado: true,
            suframaSimNao: null,

            clienteId: null,
            tipoContato: null,
            codigo: null,


            numeroSuframa: null,
            nomeFuncao: null,
            nomeContato: null,
            email: null,

            situacaoVindaDoBanco: null,
            situacaoVindaDoBancoEscrito: null,
            popupjaexiste: false,
            todainformacaobanco: [],

            popup: false,
            checkboxOrdCom:[],
            etapa: 1,
            checkboxdadoscliente:'',
            checkboxExt: false,
            inscricaoSuframa: null,

            clienteSite: null,

            numeroCelular: null,
            numeroTelefone: null,

            EmpresaArray:[],
            EstadoArray:[],
            TipoContatoArray:[],
            CidadeArray: [],
            SegmentoArray:[],
            PerfilMaterialArray: [],
            PotencialArray: [],

            popupICMS: false,
            popupPIS: false,
            popupIPI: false,
            popuptelefones: false,

            botaoICMS: false,
            botaoIPI: false,
            botaoPIS: false,

            ICMSArray: [],
            PISArray: [],
            IPIArray: [],

            teleexterior: false,
            telefoneExterior: null,
            celularExterior: null,

            //CEP
            cepValue: null,

            ufValue: null,
            cidadeValue: null,
            endereco: '',
            cep: '',
            bairro: '',
            complemento: '',
            EdicaoBack: false,
            AllCity: [],
            editando: false,
            escritobotao: true,
            largura: "292px",
            DesativaEstado: false,
            objCliente: new ClienteDesenvolvimentoViewModel(),
            TipoContato: null,
            cv: null,
            codigoGenerico: null,
            aparecerAvisoJaExiste: false,
            arquivosIds: [],

          }
        },

    methods: {
    preencheEmpresa(){
    if(this.$store.state.cliente != null && this.$store.state.cliente.possuiEmpresaEdicao && this.$store.state.cliente.clienteSituacao == 1){
      this.objCliente.EmpresaSelecionada = this.$store.state.cliente.empresaId
      return
    }
    this.objCliente.EmpresaSelecionada = this.$store.state.empresaSelecionadaId;
    },
    ImageEdit(){
      this.$isLoading(true)
      let tipo = ''

      if(this.popupICMS == true){
        tipo = 'ICMS'
      }

      else if(this.popupIPI == true){
        tipo = 'IPI'
      }

      else if(this.popupPIS == true){
       tipo = 'PIS'
      }
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `Arquivo/getArquivo`,
        data: {
          tipo : tipo,
          Arquivos: this.arquivosIds,
          ClienteId: this.clienteId,
        }
      })
      .then((response) => {
        this.imageArray = response.data.data
        this.AbrirPopupImage()
      })
      .catch(() => {
      });


    },

    deleteImage(id) {
      let arquivoid = id;
      this.$isLoading(true)
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `Arquivo/deleteArquivo/${arquivoid}`,
      })
      .then(() => {
        this.$isLoading(false)
        this.ImageEdit()
      })
      .catch(() => {
      });
    },

    AbrirPopupImage(){
      this.popupEditImage = true
      this.$isLoading(false)
    },

    atualizaEmpresaRepresentante(){
      // this.objCliente.EmpresaSelecionada = this.$store.state.empresaSelecionadaId;
      this.objCliente.RepresentanteId = this.$store.state.representanteSelecionadoId ? this.$store.state.representanteSelecionadoId : this.$store.state.cliente.representanteId;
    },

    conferecnpjApiJaExiste(){
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'Cliente/cnpjComApi',
        data:
        {
          cnpj: this.objCliente.cnpj.replace(/[\D]/gm,''),
          UnidadeId: this.objCliente.EmpresaSelecionada,
          checkboxExt: this.objCliente.checkboxExt,
          RepresentanteId: this.$store.state.representanteSelecionadoId,
          sintegra: false
        }
      })
      .then((response) => {
        this.codigoGenerico = response.data.codigoGenerico
        // this.situacaoVindaDoBanco = response.data.data.clienteSituacao
        //se o codigo generico for 0 ou 3 ele vai abrir o popup com a mensagem
        if(response.data.codigoGenerico == 0 || response.data.codigoGenerico == 3 || response.data.codigoGenerico == 4)
        {
          this.aparecerAvisoJaExiste = true
          this.objCliente = new ClienteDesenvolvimentoViewModel();
          this.objCliente.EmpresaSelecionada = this.$store.state.empresaSelecionadaId;
          this.objCliente.RepresentanteId = this.$store.state.representanteSelecionadoId

          return
        }

        if(response.data.codigoGenerico == 1 ) //existe mas nao pra essa empresa. verificar se é desenv ou ficha e permitir o usuario escolher editar
        {
          this.todainformacaobanco = response.data.data

          if(response.data.codigoGenerico == 2){
            this.popupjaexiste=true  //fazer popup aparecer somente quando achar o cnpj ja registrado no campo


            this.$store.state.cliente = response.data.data
            this.$store.commit('salvando');
            this.situacaoVindaDoBanco= response.data.data.clienteSituacaoSwitch

          }
        }
      })
      .catch(() => {
      });
    },

    verificaCPNJExistenteOuNao() {
      if(this.objCliente.cnpj.length == 18) {
        var result = Tools.validaCNPJ(this.objCliente.cnpj)
        if (result == false) {
          this.$toast.add({ severity: 'error', summary: 'CNPJ invalido', life: 5000 });
          this.objCliente.cnpj = null
        }
        else {
          this.conferecnpjApiJaExiste()
        }
      }
    },

    verificaCPNJ() {
      if(this.objCliente.cnpj.length == 18) {
        var result = Tools.validaCNPJ(this.objCliente.cnpj)
        if (result == false) {
          this.$toast.add({ severity: 'error', summary: 'CNPJ invalido', life: 5000 });
          this.objCliente.cnpj = null
        }
        else {
          if(this.$store.state.representanteSelecionadoNome == "ADMINISTRADOR"){
            this.$toast.add({ severity: 'error', summary: 'ATENÇÃO!', detail: 'Não é permitido cadastrar clientes com o representante ADMINISTRADOR', life: 4000 });
            return
          }
          this.conferecnpjApi()
        }
      }
    },

    excluir(data) {
      let dataEmString = JSON.stringify(data)
      this.index = this.index - 1
      this.informacaotelefone = this.informacaotelefone.filter(e => JSON.stringify(e) != dataEmString)
    },

    getlinha(data, index){
      this.testeindex = index
      this.testedata = data
    },

    editar(data){
      this.TipoContato = {text: 'Comercial', value: 0, enum: 0}
      this.editando = true
      this.nomeContato = data.NomeContato
      this.nomeFuncao= data.NomeFuncao
      this.clienteSite = data.Site
      this.numeroTelefone =  data.NumeroTelefone
      this.numeroCelular = data.NumeroCelular,
      this.email = data.Email,
      this.telefoneExterior = data.TelefoneExterior,
      this.celularExterior = data.CelularExterior,
      this.sequencia = data.sequencia
      this.popuptelefones = true
    },

    editarBotao() {

      if (this.email != null)
      {
        // eslint-disable-next-line
        let validacaoEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (!this.email.match(validacaoEmail))
        {
          this.$toast.add({ severity: 'error', summary: 'Email Inválido', detail: 'Adicione um email válido', life: 4000 });
          return;
        }
      }

      if (this.email == null ||  this.email == '') {
        this.$toast.add({ severity: 'error', summary: 'Não é possível adicionar', detail: 'Email é obrigatório', life: 4000 });
      }


      if (this.numeroTelefone == null ||  this.numeroTelefone == '') {
        this.$toast.add({ severity: 'error', summary: 'Não é possível adicionar', detail: 'Telefone é obrigatório', life: 4000 });
      }

      if (this.nomeContato == null ||  this.nomeContato == '') {
        this.$toast.add({ severity: 'error', summary: 'Não é possível adicionar', detail: 'Nome do contato é obrigatório', life: 4000 });
      }

      this.informacaotelefone[this.testeindex].NomeContato = this.nomeContato,
      this.informacaotelefone[this.testeindex].NomeFuncao = this.nomeFuncao,
      this.informacaotelefone[this.testeindex].TipoContato = this.TipoContato.text,
      this.informacaotelefone[this.testeindex].TipoContatoValue = this.TipoContato.value,
      this.informacaotelefone[this.testeindex].Site = this.clienteSite,
      this.informacaotelefone[this.testeindex].NumeroTelefone =  this.numeroTelefone,
      this.informacaotelefone[this.testeindex].NumeroCelular = this.numeroCelular,
      this.informacaotelefone[this.testeindex].Email = this.email,
      this.informacaotelefone[this.testeindex].TelefoneExterior = this.telefoneExterior,
      this.informacaotelefone[this.testeindex].CelularExterior = this.celularExterior
      this.informacaotelefone[this.testeindex].index = this.sequencia


      this.popuptelefones = false
    },

    async getCEP() {

      if(this.cep === ""){
        this.objCliente.cidadeValue = null;
        this.ufValue = null;
        this.ValidaCEP()
      } else{
        var dados = await CepService.getCep(this.cep)
        this.objCliente.cidadeValue = dados.nomeCidade;
        this.ufValue = dados.ufSigla;
        this.bairro = dados.bairro;
        this.ValidaCEP()
        let data = {
          nomeCidade: this.objCliente.cidadeValue,
          siglaEstado: this.ufValue,
          bairroCidade: this.bairro
        }
        this.AddCidade(data)
      }
    },

    ValidaCEP(){
      if(this.cep !== ""){
        this.DesativaEstado = true
        this.DesativaCidade = true
      } else{
        this.DesativaCidade = false
        this.DesativaEstado = false
        this.objCliente.cidadeValue = null
        this.ufValue = null
      }
    },

    AddCidade(data){
      this.axios({
        method: 'post',
        data: data,
        url: process.env.VUE_APP_WEB_API + `Cidade/GetCidadeByNameFicha`,
      })
      .then((response) => {
        this.ehEdicao=true;
        this.objCliente.CidadeSelecionada = response.data.data.id
        this.objCliente.EstadoSelecionado = response.data.data.estadoId

        this.buscarcidade()

      })
      .catch(() => {
      });
    },

    verificanomecidade (){
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'Cidade/GetNomeCidade',
        data: {
          Id: this.objCliente.CidadeSelecionada
        }
      })
        .then((response) => {

          this.objCliente.cidadenome = response.data.data.nomeCidade

        })
        .catch(() => {
        });
    },

    conferecnpj(){
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'Cliente/cnpj',
        data:
        {
          cnpj: this.objCliente.cnpj.replace(/[\D]/gm,''),
          checkboxExt: this.objCliente.checkboxExt,
        }
      })
        .then((response) => {
          this.todainformacaobanco = response.data.data
          this.$store.state.cliente = response.data.data

          this.$store.commit('salvando');

          this.situacaoVindaDoBanco= response.data.data.clienteSituacaoSwitch

          if(response.data.data != null){
            this.popupjaexiste=true; //fazer popup aparecer somente quando achar o cnpj ja registrado no campo
          }

        })
        .catch(() => {
        });

      },

    conferecnpjApi(){
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'Cliente/cnpjComApi',
        data:
        {
          cnpj: this.objCliente.cnpj.replace(/[\D]/gm,''),
          UnidadeId: this.objCliente.EmpresaSelecionada,
          checkboxExt: this.objCliente.checkboxExt,
          RepresentanteId: this.$store.state.representanteSelecionadoId,
          sintegra: true
        }
      })
      .then((response) => {

        this.codigoGenerico = response.data.codigoGenerico
        if(this.codigoGenerico == null){
        this.$toast.add({ severity: 'info', summary: '', detail: response.data.message, life: 4000 });
        return

        }
        // this.situacaoVindaDoBanco = response.data.data.clienteSituacao
        //se o codigo generico for 0 ou 3 ele vai abrir o popup com a mensagem
        if(response.data.codigoGenerico == 0 || response.data.codigoGenerico == 3)
        {
          this.aparecerAvisoJaExiste = true
          this.objCliente = new ClienteDesenvolvimentoViewModel();
          this.objCliente.EmpresaSelecionada = this.$store.state.empresaSelecionadaId;
          this.objCliente.RepresentanteId = this.$store.state.representanteSelecionadoId

          return
        }



        if(response.data.codigoGenerico == 1 || response.data.codigoGenerico == 2) //existe mas nao pra essa empresa. verificar se é desenv ou ficha e permitir o usuario escolher editar
        {
          this.todainformacaobanco = response.data.data

          if(response.data.codigoGenerico == 1) //ele nao existe e vai bater no sintegra, se tiver dados tem q trazer
          {
            let data = {
              nomeCidade: this.todainformacaobanco.nomeCidade,
              siglaEstado: this.todainformacaobanco.siglaEstado,
              bairroCidade: this.todainformacaobanco.enderecoPadrao.bairro
            }
            this.cep = this.todainformacaobanco.enderecoPadrao.cep

            this.objCliente.razaoSocial = this.todainformacaobanco.razaoSocial
            this.objCliente.nomeFantasia = this.todainformacaobanco.nomeFantasia
            this.objCliente.telefone = this.todainformacaobanco.telefoneCelular

            this.AddCidade(data)

            return
          }

          if(response.data.codigoGenerico == 2){
            this.popupjaexiste=true  //fazer popup aparecer somente quando achar o cnpj ja registrado no campo


            this.$store.state.cliente.clienteSituacao = 1
            this.$store.state.cliente = response.data.data
            this.$store.commit('salvando');
            this.situacaoVindaDoBanco= response.data.data.clienteSituacaoSwitch


            // this.objCliente.cnpj = this.$store.state.cliente.cnpj
            this.objCliente.razaoSocial = this.$store.state.cliente.razaoSocial

            this.objCliente.nomeFantasia = this.$store.state.cliente.nomeFantasia
            this.cep = (this.$store.state.cliente.enderecos).map(item => {return item.cep})[0]
            this.objCliente.EstadoSelecionado = this.$store.state.cliente.estadoId
            this.objCliente.CidadeSelecionada = this.$store.state.cliente.cidadeId

            this.objCliente.ClienteTipoId= this.$store.state.cliente.clienteTipoId
            this.objCliente.PerfilMaterialSelecionado = this.$store.state.cliente.perfilMaterial
            this.objCliente.PotencialSelecionado = this.$store.state.cliente.potencialCliente

            this.objCliente.nomeFantasia = this.todainformacaobanco.nomeFantasia

            this.objCliente.telefone = this.todainformacaobanco.telefoneCelular

            this.codigo= this.$store.state.cliente.codigoExterno
            this.cv = this.$store.state.cliente.curvaCliente

            this.objCliente.pis = this.$store.state.cliente.pisCofins
            this.objCliente.icms = this.$store.state.cliente.icms
            this.objCliente.ipi = this.$store.state.cliente.ipi

            // this.objCliente.NumeroSuframa = this.$store.state.cliente.numeroSuframa

            // this.$store.state.cliente.contatos.forEach((Element) => {
            //   let variavel =
            //   {"Sequencia": Element.sequencia, "TipoContato": Element.tipoContatoText, "TipoContatoValue": Element.tipoContato, "NomeContato": Element.nomeContato, "NomeFuncao": Element.nomeFuncao,
            //   "Site": Element.clienteSite, "Email": Element.email, "NumeroTelefone": Element.numeroTelefone, "NumeroCelular": Element.numeroCelular,
            //   "TelefoneExterior": Element.numeroTelefoneExterior, "CelularExterior": Element.numeroCelularExterior}

            //   this.informacaotelefone.push(variavel)
            // })

            // if(this.$store.state.cliente.possuiEmpresaEdicao == true){
            //   this.objCliente.EmpresaSelecionada = this.$store.state.cliente.empresaId
            // }
            // this.buscarcidade()

            // if(this.$store.state.cliente.numeroSuframa != null || this.$store.state.cliente.numeroSuframa !== '')
            // {
            //   this.suframaSimNao = 'sim'
            //   this.verificanomecidade()
            // }
            // return
          }
        }


      })
      .catch(() => {
      });

    },
    camponumero($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57)) { // 46 is dot
        $event.preventDefault();
      }
    },

    editarcnpjexistente(){
      if(this.situacaoVindaDoBanco == 1)
      {
        this.ehEdicao=true;

        this.informacaotelefone = []

        this.$router.push('/cliente-em-desenvolvimento')
        this.popupjaexiste= false

        this.$store.state.empresaSelecionadaCliente = this.objCliente.EmpresaSelecionada;
        this.$store.commit('salvando');

        this.objCliente.cnpj = this.$store.state.cliente.cnpj
        this.objCliente.razaoSocial = this.$store.state.cliente.razaoSocial

        this.objCliente.nomeFantasia = this.$store.state.cliente.nomeFantasia
        this.cep = (this.$store.state.cliente.enderecos).map(item => {return item.cep})[0]
        this.objCliente.EstadoSelecionado = this.$store.state.cliente.estadoId
        this.objCliente.CidadeSelecionada = this.$store.state.cliente.cidadeId

        this.objCliente.ClienteTipoId= this.$store.state.cliente.clienteTipoId
        this.objCliente.PerfilMaterialSelecionado = this.$store.state.cliente.perfilMaterial
        this.objCliente.PotencialSelecionado = this.$store.state.cliente.potencialCliente

        this.objCliente.telefone = this.$store.state.cliente.telefoneCelular
        this.codigo= this.$store.state.cliente.codigoExterno
        this.cv = this.$store.state.cliente.curvaCliente

        this.objCliente.pis = this.$store.state.cliente.pisCofins
        this.objCliente.icms = this.$store.state.cliente.icms
        this.objCliente.ipi = this.$store.state.cliente.ipi

        this.buscarcidade()

        this.objCliente.NumeroSuframa = this.$store.state.cliente.numeroSuframa

        if(this.$store.state.cliente.numeroSuframa != null || this.$store.state.cliente.numeroSuframa !== '')
        {
          this.suframaSimNao = 'sim'
          this.verificanomecidade()
        }
        this.$store.state.cliente.contatos.forEach((Element) => {

        let variavel =
          {"TipoContato": Element.tipoContatoText, "TipoContatoValue": Element.tipoContato, "NomeContato": Element.nomeContato, "NomeFuncao": Element.nomeFuncao,
          "Site": Element.clienteSite, "Email": Element.email, "NumeroTelefone": Element.numeroTelefone, "NumeroCelular": Element.numeroCelular,
          "TelefoneExterior": Element.numeroTelefoneExterior, "CelularExterior": Element.numeroCelularExterior}

          this.informacaotelefone.push(variavel)
        })

        this.popularDropDownSegmento()
        this.popularDropDownTipoContato()
      }
      else
      {
        this.$router.push('/ficha-cadastro')
      }

    },

    cancelarcadastrarcnpj(){
      this.popupjaexiste=false,
      this.objCliente.cnpj=null,
      this.objCliente.checkboxExt=false
    },

    setCidade () {
      let cidade = this.CidadeArray.find((Element) => Element.id == this.objCliente.CidadeSelecionada)
      let estado = this.EstadoArray.find((Element) => Element.id == cidade.estadoId)

      if(estado)
        this.objCliente.EstadoSelecionado = estado.id

        this.objCliente.cidadenome = cidade.nomeCidade



    },

    uploadIPI(e){

      let fileArray = e.files
      let data =  new FormData()
      for (var fileCounter = 0; fileCounter < (fileArray).length; fileCounter++) {
        data.append('arquivo', fileArray[fileCounter])
        data.append('nome', this.objCliente.nomeFantasia)
      }

      this.axios({
        method: 'Post',
        data: data,
        url:process.env.VUE_APP_WEB_API + 'Arquivo/postIpi',
        headers:{'Content-Type': 'multipart/form-data'}
      })
        .then((respon) => {
          this.IPIArray = respon.data.data
          // this.arquivosIds.push({
          //   ArquivoId: respon.data.data[0],
          //   Tipo: 2
          // })

          this.IPIArray.forEach((Element) => {
            this.arquivosIds.push({
              ArquivoId: Element,
              Tipo: 2
            })})


          this.$toast.add({severity:'success', summary: 'Enviado', detail:'Arquivo IPI enviado com sucesso!', life: 4000});
        })
        .catch(() => {
          this.$toast.add({severity:'error', summary: 'Erro', detail:'Erro ao enviar o Arquivo IPI', life: 4000});
        });

    },

    uploadPIS(e){

      let fileArray = e.files
      let data =  new FormData()
      for (var fileCounter = 0; fileCounter < (fileArray).length; fileCounter++) {
        data.append('arquivo', fileArray[fileCounter])
        data.append('nome', this.objCliente.nomeFantasia)
      }

      this.axios({

        method: 'Post',
        data: data,
        url:process.env.VUE_APP_WEB_API + 'Arquivo/postPis',
        headers:{'Content-Type': 'multipart/form-data'}
      })
        .then((respon) => {
          this.$toast.add({severity:'success', summary: 'Enviado', detail:'Arquivo PIS/COFINS enviado com sucesso!', life: 4000});
          this.PISArray = respon.data.data
          // this.arquivosIds.push({
          //   ArquivoId: respon.data.data[0],
          //   Tipo: 1
          // })
          this.PISArray.forEach((Element) => {
            this.arquivosIds.push({
              ArquivoId: Element,
              Tipo: 1
            })})

        })
        .catch(() => {
          this.$toast.add({severity:'error', summary: 'Erro', detail:'Erro ao enviar o Arquivo PIS/COFINS', life: 4000});
        });

    },

    uploadICMS(e){
      let fileArray = e.files
      let data =  new FormData()
      for (var fileCounter = 0; fileCounter < (fileArray).length; fileCounter++) {
        data.append('arquivo', fileArray[fileCounter])
        data.append('nome', this.objCliente.nomeFantasia)
      }
      this.axios({

        method: 'Post',
        data: data,
        url:process.env.VUE_APP_WEB_API + 'Arquivo/postIcms',
        headers:{'Content-Type': 'multipart/form-data'}
      })
        .then((respon) => {
          this.ICMSArray = respon.data.data
          // this.arquivosIds.push({
          //   ArquivoId: respon.data.data[0],
          //   Tipo: 0
          // })

          this.ICMSArray.forEach((Element) => {
            this.arquivosIds.push({
              ArquivoId: Element,
              Tipo: 0
            })})


          this.$toast.add({severity:'success', summary: 'Enviado', detail:'Arquivo ICMS enviado com sucesso!', life: 4000});
        })
        .catch(() => {
          this.$toast.add({severity:'error', summary: 'Erro', detail:'Erro ao enviar o Arquivo ICMS', life: 4000});
        });

    },

    AdicionarNaTabela(){
        this.editando = false

        var selectedContato = ''
        if (this.email != null)
        {
          // eslint-disable-next-line
          let validacaoEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if (!this.email.match(validacaoEmail))
          {
            this.$toast.add({ severity: 'error', summary: 'Email Inválido', detail: 'Adicione um email válido', life: 4000 });
            return;
          }
        }
        if (this.TipoContato != null) {
          selectedContato = this.TipoContato.text
        }

        if (this.nomeContato == null ||  this.nomeContato == '') {
          this.$toast.add({ severity: 'error', summary: 'Não é possível adicionar', detail: 'Nome do contato é obrigatório', life: 4000 });
        }


        if (this.TipoContato == null ||  this.TipoContato == '') {
          this.$toast.add({ severity: 'error', summary: 'Não é possível adicionar', detail: 'Tipo de Contato é obrigatório', life: 4000 });
        }

        if (!this.TipoContato) {
          this.$toast.add({ severity: 'error', summary: 'Não é possível adicionar', detail: 'Tipo de Contato é obrigatório', life: 4000 });
        }

        if (this.TipoContato.text == '') {
          this.$toast.add({ severity: 'error', summary: 'Não é possível adicionar', detail: 'Tipo de Contato é obrigatório', life: 4000 });
        }

        if (this.email == null ||  this.email == '') {
          this.$toast.add({ severity: 'error', summary: 'Não é possível adicionar', detail: 'E-mail é obrigatório', life: 4000 });
        }

        if (this.numeroTelefone == null ||  this.numeroTelefone == '') {
          this.$toast.add({ severity: 'error', summary: 'Não é possível adicionar', detail: 'Telefone é obrigatório', life: 4000 });
          return
        }

        if (this.numeroCelular == null ||  this.numeroCelular == '') {
          this.$toast.add({ severity: 'error', summary: 'Não é possível adicionar', detail: 'Celular é obrigatório', life: 4000 });
          return
        }

        this.index = this.index + 1;
        this.sequencia  = this.informacaotelefone.length + 1
        let variavel =
        {"Sequencia": this.sequencia, "TipoContato": selectedContato, "TipoContatoValue": this.TipoContato.value,"NomeContato": this.nomeContato, "NomeFuncao": this.nomeFuncao,
        "Site": this.clienteSite, "Email": this.email, "NumeroTelefone": this.numeroTelefone, "NumeroCelular": this.numeroCelular,
        "TelefoneExterior": this.telefoneExterior, "CelularExterior": this.celularExterior}

        this.informacaotelefone.push(variavel)
        this.TipoContato= {text: ''}
        this.nomeContato=null
        this.nomeFuncao=null
        this.clienteSite=null
        this.email=null
        this.numeroCelular=null
        this.numeroTelefone=null
        this.popuptelefones = false,
        this.celularExterior= null,
        this.telefoneExterior=null
        this.sequencia = 0
    },

    popupadicionar(){
      this.TipoContato= {text: 'Comercial', value: 0, enum: 0}
      this.nomeContato=null
      this.nomeFuncao=null
      this.clienteSite=null
      this.email=null
      this.numeroCelular=null
      this.numeroTelefone=null
      this.popuptelefones = false,
      this.celularExterior= null,
      this.telefoneExterior=null
      this.editando=false
        this.popuptelefones = true
    },

    cancelartelefone(){
      this.popuptelefones = false
      this.editando = false
    },

    adicionacelular() {
      this.inputscelular.push({
        numeroCelular: "",
      })
    },

    adicionaTelefone() {
        this.inputs.push({
          numeroTelefone: "",
        })
    },

    limparpt1(){
        this.$store.commit('limpandoCliente');
        this.DesativaCidade = false
        this.DesativaEstado = false
        this.cep = null
        this.objCliente = new ClienteDesenvolvimentoViewModel();
    },

    limpar(){
      this.$store.commit('limpandoCliente');
      this.DesativaCidade = false
      this.DesativaEstado = false
      this.cep = null
      this.objCliente.cnpj = null
      this.codigo = null
      this.objCliente.razaoSocial = null
      this.objCliente.nomeFantasia =null
      this.objCliente.CidadeSelecionada = {}
      this.objCliente.EstadoSelecionado = {}
      this.objCliente.NumeroSuframa= null
      this.objCliente.EmpresaSelecionada= null
      this.objCliente.ClienteTipoId= null
      this.objCliente.PerfilMaterialSelecionado = null
      this.objCliente.PotencialSelecionado= null
      this.objCliente.icms = false
      this.objCliente.ipi = false
      this.objCliente.pis = false
      this.nomeContato = null
      this.nomeFuncao = null
      this.codigo =null
      this.tipoContato = null
      this.clienteSite = null
      this.email = null
      this.numeroTelefone = null
      this.numeroCelular = null
    },

    limparpt2(){
      //limpar o grid, não mais os campos, isso está inutil
      this.$store.commit('limpandoCliente');
      this.nomeContato = null
      this.nomeFuncao = null
      this.codigo =null
      this.tipoContato = null
      this.clienteSite = null
      this.email = null
      this.numeroTelefone = null
      this.numeroCelular = null
      this.cv = null
      this.telefoneExterior = null
      this.celularExterior = null
      this.DesativaCidade = false
      this.DesativaEstado = false
      this.cep = null
      this.objCliente = new ClienteDesenvolvimentoViewModel();
      this.informacaotelefone = []
      EmpresaController.getEmpresasAtivas().requisicao
      .then(response => {
        this.EmpresaArray = response.data.data
        this.atualizaEmpresaRepresentante()
      });

      this.mitt.on('trocaEmpresaRepresentante', () => {
        this.atualizaEmpresaRepresentante()
      })
    },

    popularDropDownTipoContato(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'ClienteDesenvolvimento/TipoContato/Get',
      })
        .then((response) => {
          this.TipoContatoArray = response.data
        })
        .catch(() => {
        });
    },

    popularDropDownPotencial(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'ClienteDesenvolvimento/Potencial/Get',
      })
        .then((response) => {
          this.PotencialArray = response.data
        })
        .catch(() => {
        });
    },

    popularDropDownPerfilMaterial(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'ClienteDesenvolvimento/PerfilMaterial/Get',
      })
        .then((response) => {
          this.PerfilMaterialArray = response.data
        })
        .catch(() => {
        });
    },

    popularDropDownSegmento(){
      this.SegmentoArray = ClienteController.getClienteTipo().Segmentos;
    },

    cidades_exterior(){

      if(this.objCliente.checkboxExt === true )
      {
        this.DesativaEstado = true
        this.axios({
          method: 'post',
          url: process.env.VUE_APP_WEB_API + 'Cidade/getEstadoExterior',

        })
          .then((response) => {
            this.objCliente.EstadoSelecionado=response.data.data.estadoId
            this.buscarcidade()
          })
          .catch(() => {
          });
      }
      else{
        this.DesativaEstado=false
        this.objCliente.EstadoSelecionado={}
      }

    },

    cnpjExterior() {
        if(this.objCliente.checkboxExt === true){
          this.objCliente.EstadoSelecionado = null
        }
        this.objCliente.checkboxExt === false ? this.DesativaEstado = true : this.DesativaEstado = false
        // this.objCliente.checkboxExt === false ? this.desabilitarcep = true : this.desabilitarcep = false
        this.objCliente.checkboxExt === false ? this.objCliente.cnpj = '111111111000011' : this.objCliente.cnpj = null
        this.objCliente.checkboxExt === false ? this.teleexterior = true : this.teleexterior = false
        this.objCliente.checkboxExt === false ? this.desabilitado = true : this.desabilitado = false
        this.objCliente.checkboxExt === false ? this.cepValue = null : this.cepvalue = null

    },

    uploadArquivoICMS(){
      this.botaoICMS === false ? this.botaoICMS = true : this.botaoICMS = false
    },

    uploadArquivoPIS(){
      this.botaoPIS === false ? this.botaoPIS = true : this.botaoPIS = false
    },

    uploadArquivoIPI(){
      this.botaoIPI === false ? this.botaoIPI = true : this.botaoIPI = false
    },

    AbrirpopupICMS(){
      this.popupICMS=true
    },

    AbrirpopupPIS(){
      this.popupPIS=true
    },

    AbrirpopupIPI(){
      this.popupIPI=true
    },

    Fecharicms(){
      this.popupICMS=false
    },

    fecharpis(){
      this.popupPIS=false
    },
    fecharIPI(){
      this.popupIPI=false
    },

    buscarcidade(){
        this.axios({
            method: 'post',
            url: process.env.VUE_APP_WEB_API + 'Cidade/getbyestado',
            data: {
                id: this.objCliente.EstadoSelecionado
            }
          })
            .then((response) => {
              this.CidadeArray = response.data.data
            })
            .catch(() => {
            });
    },

    buscarCidadeSemEstado(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.AllCity = CidadeController.getByCidadeEstado(event).CidadeArray;
        this.CidadeArray = CidadeController.getByCidadeEstado(event).CidadeArray;
      }, 1000);
    },

    popularDropDownEstado(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'Estado/get',
      })
        .then((response) => {
          this.EstadoArray = response.data.data
        })
        .catch(() => {
        });
    },

    voltar (){
      this.etapa = 1;
    },

    gravar(){
      let erros = this.v$.$silentErrors;
      let invalido = this.v$.$invalid;
      if (invalido)
        {
          this.escritobotao = true
          this.largura = "292px"
          erros.forEach(erro => {
            this.$toast.add({
              severity: 'error',
              summary: 'Campo não preenchido',
              detail: erro.$message,
              life: 3000
            });
          })
        }
        else {
          if(this.telefoneCelularInvalido == true && this.objCliente.telefone)
            {
              this.$toast.add({severity:'error', summary: 'Erro', detail:'Formato de Telefone/Celular inválido', life: 4000});
              return
              }
              if(this.$store.state.representanteSelecionadoNome == "ADMINISTRADOR"){
                this.$toast.add({ severity: 'error', summary: 'ATENÇÃO!', detail: 'Não é permitido cadastrar clientes com o representante ADMINISTRADOR', life: 4000 });
                return
              }


      if(this.$store.state.cliente != null && this.$store.state.cliente.clienteSituacao == 1)
      {
        // SE FOR EDIÇÃO VAI FIRETO PRA SALVAR
            this.desabilitaGravar= true
            this.escritobotao = false
            this.largura = "35px"
            this.objCliente.Arquivos = this.arquivosIds
            this.objCliente.cep = this.cep
            setTimeout(() => {
              this.$isLoading(true)
            this.objCliente.cnpj = this.objCliente.cnpj.replace(/\D/gm, '')
            this.objCliente.cep = this.objCliente.cep.replace("-", "")
            if (this.objCliente.telefone){
              this.objCliente.telefone = this.objCliente.telefone.replace(/\D/gm, '')
            }
            // this.objCliente.telefone = this.objCliente.telefone.replace(/\D/gm, '')
            ClienteDesenvolvimentoController.SalvarClienteEmDesenvolvimento(this.objCliente).requisicao
              .then((Response ) => {
                this.desabilitaGravar = false
                if(Response.data.data){
                  this.clienteId = Response.data.data
                  this.$isLoading(false)
                  this.escritobotao = true
                  this.largura = "292px"
                  this.SalvarClienteContato();
                }
                else{
                  this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao salvar cliente. Entre em contato com o suporte.', life: 7000 });
                  this.$isLoading(false)
                  this.escritobotao = true
                  this.largura = "292px"
                }
              })
              .catch(() => {
                this.$isLoading(false)
                this.escritobotao = true
                this.largura = "292px"
              })
            } , 1100)
      }

      else{
        //SE FOR INCLUSAO PRIMEIRO VALIDA O CNPJ DEPOIS INCLUI
        this.axios({
          method: 'post',
          url: process.env.VUE_APP_WEB_API + 'Cliente/cnpjComApi',
          data:
          {
            cnpj: this.objCliente.cnpj.replace(/[\D]/gm,''),
            UnidadeId: this.objCliente.EmpresaSelecionada,
            checkboxExt: this.objCliente.checkboxExt,
            RepresentanteId: this.$store.state.representanteSelecionadoId,
            sintegra: false
          }
        })
        .then((response) => {
          this.codigoGenerico = response.data.codigoGenerico
          // this.situacaoVindaDoBanco = response.data.data.clienteSituacao
          //se o codigo generico for 0 ou 3 ele vai abrir o popup com a mensagem
          if(response.data.codigoGenerico == 0 || response.data.codigoGenerico == 3 || response.data.codigoGenerico == 4)
          {
            this.aparecerAvisoJaExiste = true
            this.objCliente = new ClienteDesenvolvimentoViewModel();
            this.objCliente.EmpresaSelecionada = this.$store.state.empresaSelecionadaId;
            this.objCliente.RepresentanteId = this.$store.state.representanteSelecionadoId
  
            return
          }
  
          if(response.data.codigoGenerico == 1 ) //existe mas nao pra essa empresa. verificar se é desenv ou ficha e permitir o usuario escolher editar
          {
            this.todainformacaobanco = response.data.data
  
            if(response.data.codigoGenerico == 2){
              this.popupjaexiste=true  //fazer popup aparecer somente quando achar o cnpj ja registrado no campo
  
  
              this.$store.state.cliente = response.data.data
              this.$store.commit('salvando');
              this.situacaoVindaDoBanco= response.data.data.clienteSituacaoSwitch
  
              return
            }
          }
  
  
              this.desabilitaGravar= true
            this.escritobotao = false
            this.largura = "35px"
            this.objCliente.Arquivos = this.arquivosIds
            this.objCliente.cep = this.cep
            setTimeout(() => {
              this.$isLoading(true)
            this.objCliente.cnpj = this.objCliente.cnpj.replace(/\D/gm, '')
            this.objCliente.cep = this.objCliente.cep.replace("-", "")
            if (this.objCliente.telefone){
              this.objCliente.telefone = this.objCliente.telefone.replace(/\D/gm, '')
            }
            // this.objCliente.telefone = this.objCliente.telefone.replace(/\D/gm, '')
            ClienteDesenvolvimentoController.SalvarClienteEmDesenvolvimento(this.objCliente).requisicao
              .then((Response ) => {
                this.desabilitaGravar = false
                if(Response.data.data){
                  this.clienteId = Response.data.data
                  this.$isLoading(false)
                  this.escritobotao = true
                  this.largura = "292px"
                  this.SalvarClienteContato();
                }
                else{
                  this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao salvar cliente. Entre em contato com o suporte.', life: 7000 });
                  this.$isLoading(false)
                  this.escritobotao = true
                  this.largura = "292px"
                }
              })
              .catch(() => {
                this.$isLoading(false)
                this.escritobotao = true
                this.largura = "292px"
              })
            } , 1100)
  
  
        })
        .catch(() => {
        });
      }
              


        }
    },

    SalvarClienteContato () {
      this.verificarAlteracaoListaContato()
        this.axios({
          method: 'post',
          url: process.env.VUE_APP_WEB_API + 'ClienteDesenvolvimento/CadastrarClienteContato',
          data: {
              clienteId: this.clienteId,
              ContatosLista: this.informacaotelefone,
              alteracaoLista: this.alteracaoListaContato,
              EmpresaId: this.objCliente.EmpresaSelecionada,
          }
        })
          .then((response) => {

            if(response.data.data){

              this.empresaSalva = this.objCliente.EmpresaSelecionada

              this.popup=true
              this.$store.commit('limpandoCliente');
              this.objCliente = new ClienteDesenvolvimentoViewModel();
              this.objCliente.telefone = ''
              this.codigo = null
              this.cep = null
              this.nomeContato = null
              this.nomeFuncao = null
              this.codigo =null
              this.tipoContato = null
              this.clienteSite = null
              this.email = null
              this.numeroTelefone = null
              this.numeroCelular = null
              this.informacaotelefone=[]
              this.DesativaCidade = false
              this.DesativaEstado = false
              this.cv = null

              EmpresaController.getEmpresasAtivas().requisicao
              .then(response => {
                this.EmpresaArray = response.data.data
                this.atualizaEmpresaRepresentante()
              });

              this.mitt.on('trocaEmpresaRepresentante', () => {
                this.atualizaEmpresaRepresentante()
              })
              setTimeout(() => {
                this.MandarClienteCRM();
              }, 3000);
            }
            else{
              this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao salvar contatos do cliente. Entre em contato com o suporte.', life: 7000 });
            }

          })
          .catch(() => {
          });

    },

    MandarClienteCRM() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Cliente/EnviarClienteCRM/${this.clienteId}/${this.empresaSalva}`,
      })
        .then(() => {
        })
        .catch(() => {
        });
    },

    fecharClienteDesenv() {
      this.CidadeArray = []
      this.etapa = 1;//TROCAR AQUI PRA ROTA NA HORA DOS STEPS
      this.$router.push(`/cliente-consulta`)
    },

    consultar(){
        this.$router.push('/cliente-consulta')
    },

    verificarAlteracaoListaContato()
    {
      this.alteracaoListaContato = true
    }


  }
}